import { useEffect, useRef, useState } from "react";
import "./FloatingAppButton.css";
import iosLogo from "../assets/logos app/Vector (2).svg";
import androidLogo from "../assets/logos app/Group (1).svg";

const APP_STORE_LINK = "https://apps.apple.com/us/app/zoco-tickets/id6758010461";
const PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=com.men7ar31.zocotickets";

export default function FloatingAppButton() {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const onDocClick = (event) => {
      if (!rootRef.current) return;
      if (!rootRef.current.contains(event.target)) setOpen(false);
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  return (
    <div
      ref={rootRef}
      className={`floating-app-button ${open ? "is-open" : ""}`}
      aria-label="Descarg� la app de ZOCO"
    >
      <button
        type="button"
        className="floating-app-button__trigger"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        aria-controls="floating-app-stores"
      >
        <span className="floating-app-button__pill">
          <span className="floating-app-button__icon" aria-hidden="true">
            <svg viewBox="0 0 20 20">
              <path d="M7.25 4.5l5.5 5.5-5.5 5.5" />
            </svg>
          </span>
          <span className="floating-app-button__label">DESCARGÁ LA APP</span>
        </span>
      </button>

      <div
        id="floating-app-stores"
        className="floating-app-button__stores"
        role="menu"
        aria-hidden={!open}
      >
        <a
          className="floating-app-button__store"
          href={APP_STORE_LINK}
          target="_blank"
          rel="noreferrer"
          role="menuitem"
          aria-label="Descargar en iOS"
        >
          <span className="floating-app-button__store-icon" aria-hidden="true">
            <img src={iosLogo} alt="" loading="lazy" />
          </span>
          <span className="floating-app-button__store-label">iOS</span>
        </a>
        <a
          className="floating-app-button__store"
          href={PLAY_STORE_LINK}
          target="_blank"
          rel="noreferrer"
          role="menuitem"
          aria-label="Descargar en Android"
        >
          <span className="floating-app-button__store-icon" aria-hidden="true">
            <img src={androidLogo} alt="" loading="lazy" />
          </span>
          <span className="floating-app-button__store-label">ANDROID</span>
        </a>
      </div>
    </div>
  );
}